import { ItemsPagination, PaginationSetting, ResponseObject, SorterConfig } from './CommonModel';
import { ObjectTypes } from './DeviceAdminModel';
import { ObjectLibraryTreeNode, ObjectSearchField } from './GraphicModel';

export type AppPermTableData = {
	key: React.Key;
	SubItemID: number;
	Name: string;
	Allowed: boolean;
};

export type ApplicationPermissionsListMember = {
	ComponentID: number;
	Name: string;
};

export type ApplicationPermission = {
	ComponentID: number;
	SubItemPermissions: ApplicationSubItemPermission[];
	RoleCan: RoleCan;
} & ResponseObject;

export type RoleCan = {
	CanAddNew: boolean;
	CanDelete: boolean;
	CanSave: boolean;
	CanView: boolean;
	ShowAddNew: boolean;
	ShowDelete: boolean;
	ShowSave: boolean;
	ShowView: boolean;
};

export type SearchType = {
	isDeepChildren?: boolean;
	searchText?: string;
	showOptions: ShowOptions;
	rootObjectTypes: ObjectTypes[];
	selectedHardwareOptions: ObjectTypes[];
	selectedSearchByHardwareTypes: ObjectTypes[];
	sortConfig: SorterConfig;
};

export type HardwarePagination = {
	HardwareTree: ObjectLibraryTreeNode;
} & ItemsPagination;

export type HardwarePermission = {
	ObjectId: number;
	ParentId?: number;
	ObjectType: ObjectTypes;
	HasPermission: boolean;
};

export type GeneralPermissionPaginationSetting = {
	SelectedObjectTypes: ObjectTypes[];
} & PaginationSetting;

export type GrantedGeneralPermission = {
	ObjectId: number;
	ObjectType: ObjectTypes;
};

export type KeyValuePair<TKey, TValue> = {
	key: TKey;
	value: TValue;
};

export type DigiTracPermission = {
	TotalSelectedItems: number;
	ControllerFullSelected: HardwarePermission[];
	ControllerDefinitions: ControllerDefinition[];
	Permissions: Record<ObjectTypes, DigiTracPermissionItem>;
};

export enum ExcludedChildren {
	None = 0,
	InputsNotIncluded = 1,
	RelaysNotIncluded = 2,
	DoorsNotIncluded = 4,
	ExpansionInputsNotIncluded = 8,
}

export type ControllerDefinition = {
	ExcludedChildren: ExcludedChildren;
	ObjectId: number;
	ParentId: number;
};

export type DigiTracPermissionItem = {
	Items: KeyValuePair<number, HardwarePermission>;
};

export enum ShowOptions {
	ShowAll = 0,
	ShowIncluded,
	ShowExcluded,
}

export type ApplicationSubItemPermission = {
	ComponentID: number;
	SubItemID: number;
	Allowed: boolean;
	Name: string;
	TabOrder: number;
};

export type ObjectPermission = {
	ObjectTypes: ObjectTypes;
	SubItemPermissions: ObjectSubItemPermission[];
} & ResponseObject;

export type ObjectSubItemPermission = {
	ObjectTypes: ObjectTypes;
	ObjectID: number;
	Allowed: boolean;
	Name: string;
};

export type GeneralSubPermissionOptions = {
	Header: string;
	ResourceId: number;
	Permissions: PermissionOptions[];
	IsPermissionsEmpty?: boolean;
	IsMouseOver?: boolean;
	HasPermissionChanged?: boolean;
};

export type PermissionOptions = {
	ObjectId: number;
	Name: string;
	IsChecked: boolean;
	HasPermissionChanged?: boolean;
	//IsChecked?: boolean;
	//RoleCan?: AppPermissionsRoleCan[];
};

//need to check this.  ResponseObject should be able to be &'ed here
export type MembersModel = {
	ObjectId: number;
	Name: string;
	DirectorySource: string;
	BelongsToGroups: string;
}; //& ResponseObject;

export type Member = {
	Index: number;
	ObjectId?: number;
	Name: string;
	DirectorySource: string;
	BelongsToGroups: string;
	BelongsToGroupsArray?: string[];
};

export enum ApplyChanges {
	ToThisItem,
	ToThisItemAndChildren,
	ToThisItemAndVisibleChildren,
}

export enum ApplyAction {
	None,
	Revoke,
	Grant,
}

export type ConfirmChangesData = {
	applyAction: ApplyAction;
	isFolder: boolean;
	currentSelectedNode: ObjectSearchField;
};

/*export type MembersModel = {
	ObjectId: number;
	Name: string;
	DirectorySource: string;
} & ResponseObject;

export type Member = {
	key: React.Key;
	Index: number;
	ObjectId?: number;
	Name: string;
	DirectorySource: string;
};*/
